/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Icd10CodeRecordModel } from '../../models/icd-10-code-record-model';

export interface Icd10CodeIdGet$Params {
  id: string;
}

export function icd10CodeIdGet(http: HttpClient, rootUrl: string, params: Icd10CodeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Icd10CodeRecordModel>> {
  const rb = new RequestBuilder(rootUrl, icd10CodeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Icd10CodeRecordModel>;
    })
  );
}

icd10CodeIdGet.PATH = '/ICD10Code/{id}';
